import React, { useState } from 'react';
import FixedMenu from '../Menus/FixedMenu';

const ExpandableImage = ({ src, alt, ratio }) => {
    const [expanded, setExpanded] = useState(false);
    const imageRatio = ratio || '16 / 9';

    return (
        <>
            {expanded && (
                <FixedMenu title={alt} iconClass="bi-image" expanded={expanded} setExpanded={setExpanded}>

                            <img src={src} alt={alt} className="w-100 h-100 object-fit-cover" />
                </FixedMenu>
            )}
            <button className="btn btn-link p-0 w-100" onClick={() => setExpanded(true)}>
                <div style={{ aspectRatio: imageRatio, overflow: 'hidden' }}>
                    <img src={src} alt={alt} className="w-100 h-100 object-fit-cover" />
                </div>
            </button>

        </>
    )
};

export default ExpandableImage;